import { UserModel, GroupModel, DashboardModel, EntityModel, HistoryModel } from './api.models' 

var API_URL = window['config'].API_URL

interface IApiResource<T> extends ng.resource.IResourceClass<ng.resource.IResource<T>> {
}

export class ApiResourceFactory {

    public login: IApiResource<UserModel>
    public locations: IApiResource<any>
    public devices: IApiResource<any>
    public dictionaries: IApiResource<any>
    public distributors: IApiResource<any>
    public groups: IApiResource<GroupModel>
    public dashboard: IApiResource<DashboardModel>
    public measurements: IApiResource<any>
    public meters: IApiResource<any>
    public users: IApiResource<EntityModel>
    public history: IApiResource<HistoryModel>
    public issues: IApiResource<any>
    public tasks: IApiResource<any>
    public app: IApiResource<any>
    public routes: IApiResource<any>
    public password: IApiResource<any>
    public alarms: IApiResource<any>
    public reports: IApiResource<any>
    public ssrs_reports: IApiResource<any>
    public scripts: IApiResource<any>
    public simcards: IApiResource<any>
    public contacts: IApiResource<any>
    public actions: IApiResource<any>
    public deviceconnections: IApiResource<any>
    public secureapp: IApiResource<any>
    public alarmGroups: IApiResource<any>
    public kpi: IApiResource<any>;
    public servicemans: IApiResource<any>
    public depositories: IApiResource<any>

    constructor($resource: ng.resource.IResourceService) {
        this.login = $resource(API_URL + 'api/login')
        this.locations = $resource(API_URL + 'api/locations/:id/:method/:guid/:type', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'getSchema': { method: 'GET', params: { method: 'schema' }, cancellable: true },
            'getSchemas': { method: 'GET', params: { method: 'schemas' }, isArray: false, cancellable: true },
            'getProfile': { method: 'GET', params: { method: 'profile' }, isArray: false, cancellable: true },
            'saveProfile': { method: 'PUT', params: { method: 'profile', type: 'save' }, isArray: false, cancellable: true },
            'saveConfigurationProfile': { method: 'PUT', params: { method: 'profileFunction', type: 'save' }, isArray: false, cancellable: true },
            'get': { method: 'GET', cancellable: true },
            'importIsCompleted': { method: 'POST', params: { method: 'import', type: 'IsCompleted' } },
            'importResume': { method: 'POST', params: { method: 'import', type: 'Resume' } },
            'importInit': { method: 'POST', params: { method: 'import', type: 'init' } },
            'importValidate': { method: 'GET', params: { method: 'import', type: 'Validate' } },
            'importGetData': { method: 'GET', params: { method: 'import', type: 'getData' } },
            'importStart': { method: 'GET', params: { method: 'import', type: 'start' } },
            'importStop': { method: 'GET', params: { method: 'import', type: 'stop' } },
            'importProgress': { method: 'GET', params: { method: 'import', type: 'progress' } },
            'importSummary': { method: 'GET', params: { method: 'import', type: 'summary' } },
            'validate': { method: 'POST', params: { method: 'validate' }, isArray: false },
            'getProblems': { method: 'POST', params: { method: 'problems', type: 'get' }, isArray: false },
            'saveProblems': { method: 'POST', params: { method: 'problems', type: 'save' }, isArray: false },
            'planDelivery': { method: 'POST', params: { method: 'delivery', type: 'plan' }, isArray: false }
        })
        this.devices = $resource(API_URL + 'api/devices/:id/:method/:guid/:type', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getDeviceToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'getParentDevices': { method: 'GET', isArray: false, params: { method: 'parent' }, cancellable: true },
            'getChildDevices': { method: 'GET', isArray: false, params: { method: 'child' }, cancellable: true },
            'saveChildDevices': { method: 'PUT', isArray: false, params: { method: 'child' } },
            'delete': { method: 'DELETE', isArray: false },
            'changeCurrentMeter': { method: 'POST', isArray: false, params: { method: 'meter' } },
            'get': { method: 'GET', cancellable: true },
            'getSchema': { method: 'GET', params: { method: 'schema' }, cancellable: true },
            'getSchemas': { method: 'GET', params: { method: 'schemas' }, isArray: false, cancellable: true },
            'getDeviceConfigurationInconsistency': { method: 'GET', params: { method: 'Inconsistency' }, isArray: false, cancellable: true },
            'importIsCompleted': { method: 'POST', params: { method: 'import', type: 'IsCompleted' } },
            'importResume': { method: 'POST', params: { method: 'import', type: 'Resume' } },
            'importInit': { method: 'POST', params: { method: 'import', type: 'init' } },
            'importValidate': { method: 'GET', params: { method: 'import', type: 'Validate' } },
            'importGetData': { method: 'GET', params: { method: 'import', type: 'getData' } },
            'importStart': { method: 'GET', params: { method: 'import', type: 'start' } },
            'importStop': { method: 'GET', params: { method: 'import', type: 'stop' } },
            'importProgress': { method: 'GET', params: { method: 'import', type: 'progress' } },
            'importSummary': { method: 'GET', params: { method: 'import', type: 'summary' } },
            'sendDeviceConfiguration': { method: 'POST', params: { method: 'SendConfiguration' }, isArray: false, cancellable: true },
        })
        this.deviceconnections = $resource(API_URL + 'api/deviceconnections/:id/:method', {}, {
            'query': {
                method: 'POST', isArray: false, timeout: 72000000, cancellable: true
            }
        })
        this.alarmGroups = $resource(API_URL + 'api/alarmGroups/:id/:method', {}, {
            'query': {
                method: 'POST', isArray: false, timeout: 72000000, cancellable: true
            },
            'get': { method: 'GET', cancellable: true },
            'getAlarmGroupsOperators': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'operators' } },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false }
        })
        this.routes = $resource(API_URL + 'api/routes/:id/:method/:guid/:type', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getRoutePoints': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'locations' } },
            'getRouteOperators': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'operators' } },
            'getRouteToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'getRouteFiles': { method: 'GET', isArray: true, params: { method: 'files' }, cancellable: true },
            'importIsCompleted': { method: 'POST', params: { method: 'import', type: 'IsCompleted' } },
            'importResume': { method: 'POST', params: { method: 'import', type: 'Resume' } },
            'importInit': { method: 'POST', params: { method: 'import', type: 'init' } },
            'importValidate': { method: 'GET', params: { method: 'import', type: 'Validate' } },
            'importGetData': { method: 'GET', params: { method: 'import', type: 'getData' } },
            'importStart': { method: 'GET', params: { method: 'import', type: 'start' } },
            'importStop': { method: 'GET', params: { method: 'import', type: 'stop' } },
            'importProgress': { method: 'GET', params: { method: 'import', type: 'progress' } },
            'importSummary': { method: 'GET', params: { method: 'import', type: 'summary' } }
        })
        this.dictionaries = $resource(API_URL + 'api/dictionary/:method/:views', {}, {
            'get': { method: 'GET', params: { method: 'dictionaries' }, timeout: 72000000, isArray: false, cancellable: true },
            'getVersion': { method: 'GET', params: { method: 'version' }, cancellable: true },
            'getAlarmTypes': { method: 'GET', params: { method: 'alarmTypes' }, cancellable: true },
            'getDictionaryReferenceTables': { method: 'POST', params: { method: 'references' }, cancellable: true }
        })
        this.distributors = $resource(API_URL + 'api/distributors/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getDistributorToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false }, 
            'delete': { method: 'DELETE', isArray: false },
            'getAllDistributors': { method: 'POST', isArray: false, params: { method: 'All' }, cancellable: true },
            'getDistributorRoles': { method: 'POST', isArray: false, params: { method: 'Roles' }, cancellable: true },
            'get': { method: 'GET', cancellable: true }
        })
        this.groups = $resource(API_URL + 'api/groups/:method/:id', {}, {
            'getLocationGroups': { method: 'POST', params: { method: 'locations' }, isArray: false, cancellable: true },
            'getAlarmGroups': { method: 'POST', params: { method: 'alarms' }, isArray: false, cancellable: true },
            'get': { method: 'GET', cancellable: true },
            'getLocationAssignedGroups': { method: 'POST', params: { method: 'locations-assigned-groups' }, isArray: false, cancellable: true }
        })
        this.dashboard = $resource(API_URL + 'api/dashboard/:method', {}, {
            'query': { method: 'POST', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'save': { method: 'PUT', cancellable: true },
            'getTemplates': { method: 'GET', isArray: true, params: { method: 'templates' }, cancellable: true },
            'validateScript': { method: 'POST', isArray: false, params: { method: 'validate' }, cancellable: true },
            'delete': { method: 'POST', isArray: false, params: { method: 'delete' }, cancellable: true },
            'getElementData': { method: 'POST', isArray: false, params: { method: 'data' }, cancellable: true}
        })
        this.measurements = $resource(API_URL + 'api/measurements/:method', {}, {
            'getMeasurementsForLocation': { method: 'POST', params: { method: 'measurements-for-location' }, isArray: false, cancellable: true },
            'getLatestMeasurementsForLocation': { method: 'POST', params: { method: 'latest-measurements-for-location' }, isArray: false, cancellable: true },
            'getMeasurementsForDevice': { method: 'POST', params: { method: 'measurements-for-device' }, isArray: false, cancellable: true },
            'getLatestMeasurementsForDevice': { method: 'POST', params: { method: 'latest-measurements-for-device' }, isArray: false, cancellable: true },
            'getMeasurementsForMeter': { method: 'POST', params: { method: 'measurements-for-meter' }, isArray: false, cancellable: true },
            'getLatestMeasurementsForMeter': { method: 'POST', params: { method: 'latest-measurements-for-meter' }, isArray: false, cancellable: true },
            'exportMeasurements': { method: 'POST', params: { method: 'export-measurements' }, isArray: false, cancellable: true}
        })
        this.meters = $resource(API_URL + 'api/meters/:id/:method/:guid/:type', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getMeterToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'changeCurrentDevice': { method: 'POST', isArray: false, params: { method: 'device' } },
            'get': { method: 'GET', cancellable: true },
            'getSchema': { method: 'GET', params: { method: 'schema' }, cancellable: true },
            'getSchemas': { method: 'GET', params: { method: 'schemas' }, isArray: false, cancellable: true },
            'getAlarmDefs': { method: 'GET', params: { method: 'alarmDefinitions' }, cancellable: true },
            'getAlarmGroups': { method: 'GET', params: { method: 'alarmGroups' }, cancellable: true },
            'importIsCompleted': { method: 'POST', params: { method: 'import', type: 'IsCompleted' } },
            'importResume': { method: 'POST', params: { method: 'import', type: 'Resume' } },
            'importInit': { method: 'POST', params: { method: 'import', type: 'init' } },
            'importValidate': { method: 'GET', params: { method: 'import', type: 'Validate' } },
            'importGetData': { method: 'GET', params: { method: 'import', type: 'getData' } },
            'importStart': { method: 'GET', params: { method: 'import', type: 'start' } },
            'importStop': { method: 'GET', params: { method: 'import', type: 'stop' } },
            'importProgress': { method: 'GET', params: { method: 'import', type: 'progress' } },
            'importSummary': { method: 'GET', params: { method: 'import', type: 'summary' } }
        })
        this.users = $resource(API_URL + 'api/users/:id/:method/:action', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getUserToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'submitActivities': { method: 'PUT', isArray: false, params: { method: 'activity', action: 'change' } },
            'submitRoles': { method: 'PUT', isArray: false, params: { method: 'role', action: 'change' } },
            'changeNotification': { method: 'POST', isArray: false, params: { method: 'notification', action: 'change' } },
            'changeReferenceObject': { method: 'POST', isArray: false, params: { method: 'activity', action: 'reference' } },
            'changeAllowedDistributors': { method: 'POST', isArray: false, params: { method: 'distributors', action: 'change' } },
            'changePassword': { method: 'POST', isArray: false, params: { method: 'password', action: 'change' } },
            'get': { method: 'GET', cancellable: true },
            'getLoggedOperator': { method: 'GET', cancellable: true, params: { method: 'logged' } },
            'getLoggedOperatorSettings': { method: 'GET', cancellable: true, isArray: true, params: { method: 'logged', action: 'settings' } },
            'getOperatorDepositoryContent': { method: 'GET', cancellable: true, isArray: false, params: { method: 'depository', action: 'content' } },
        })

        this.issues = $resource(API_URL + 'api/issues/:id/:method/:attachmentId', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getIssueToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'getAttachments': { method: 'GET', isArray: false, params: { method: 'Attachments' }, cancellable: true },
            'getTasks': { method: 'GET', isArray: false, params: { method: 'Tasks' }, cancellable: true },
            'getEquipment': { method: 'GET', isArray: false, params: { method: 'Equipment' }, cancellable: true }, 
            'delete': { method: 'DELETE', isArray: false },
            'saveAttachment': { method: 'POST', isArray: false, params: { method: 'Attachments' } },
            'deleteAttachment': { method: 'PUT', isArray: false, params: { method: 'Attachments' } },
            'checkIfAttachmentExists': { method: 'GET', isArray: false, params: { method: 'CheckIfAttachmentExists' } },
            'get': { method: 'GET', cancellable: true }
        })
        this.tasks = $resource(API_URL + 'api/tasks/:id/:method/:attachmentId', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getTaskToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'getAttachments': { method: 'GET', isArray: false, params: { method: 'Attachments' }, cancellable: true },
            'getEquipment': { method: 'GET', isArray: false, params: { method: 'Equipment' }, cancellable: true },
            'saveAttachment': { method: 'POST', isArray: false, params: { method: 'Attachments' } },
            'deleteAttachment': { method: 'PUT', isArray: false, params: { method: 'Attachments' } },
            'checkIfAttachmentExists': { method: 'GET', isArray: false, params: { method: 'CheckIfAttachmentExists' } },
            'get': { method: 'GET', cancellable: true },
            'getAvailableStatuses': { method: 'POST', isArray: false, params: { method: 'AvailableStatuses' } },
            'saveTaskStatuses': { method: 'PUT', isArray: false, params: { method: 'SaveTaskStatuses' } },
            'getTaskPayments': { method: 'GET', isArray: false, params: { method: 'TaskPayments' } },
            'validate': { method: 'POST', params: { method: 'validate' }, isArray: false }
        })

        this.alarms = $resource(API_URL + 'api/alarms/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getAlarmToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'getAlarmSummary': { method: 'GET', isArray: false, params: { method: 'summary' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'confirmAlarms': { method: 'POST', isArray: false, params: { method: 'confirmAlarms' }, timeout: 72000000, cancellable: true },
        })

        this.history = $resource(API_URL + 'api/history/:method/:id', {}, {
            'getLocationHistory': { method: 'GET', isArray: false, params: { method: 'location' }, cancellable: true },
            'getDeviceHistory': { method: 'GET', isArray: false, params: { method: 'Device' }, cancellable: true },
            'getMeterHistory': { method: 'GET', isArray: false, params: { method: 'Meter' }, cancellable: true },
            'getIssueHistory': { method: 'GET', isArray: false, params: { method: 'Issue' }, cancellable: true },
            'getTaskHistory': { method: 'GET', isArray: false, params: { method: 'Task' }, cancellable: true },
            'getSimcardHistory': { method: 'GET', isArray: false, params: { method: 'Simcard' }, cancellable: true  },
            'getActionHistory': { method: 'GET', isArray: false, params: { method: 'Action' }, cancellable: true },
            'getAlarmHistory': { method: 'GET', isArray: false, params: { method: 'Alarm' }, cancellable: true },
            'getReportHistory': { method: 'GET', isArray: false, params: { method: 'Report' }, cancellable: true }
        })

        this.app = $resource(API_URL + 'api/app/:method', {}, {
            'getRoles': { method: 'POST', isArray: false, params: { method: 'roles' }, cancellable: true },
            'getActivities': { method: 'POST', isArray: false, params: { method: 'activities' }, cancellable: true },
            'getStates': { method: 'POST', isArray: false, params: { method: 'states' }, cancellable: true },
            'importExcelFile': { method: 'POST', isArray: false, params: { method: 'excel' } },
            'get': { method: 'GET', cancellable: true },
            'getContextList': { method: 'POST', isArray: true, params: { method: 'contextlist' }, timeout: 72000000, cancellable: true },
            'getCorrespondingActionType': { method: 'POST', isArray: true, params: { method: 'correspondingActionType' }, timeout: 72000000, cancellable: true },
            'sendAction': { method: 'POST', isArray: true, params: { method: 'sendAction' }, timeout: 72000000, cancellable: true },
            'saveReqModel': { method: 'POST', isArray: false, params: { method: 'requestmodel' }, timeout: 72000000, cancellable: true },
            'saveMeasReqModel': { method: 'POST', isArray: false, params: { method: 'MeasurementsRequestModel' }, timeout: 72000000, cancellable: true }            
        })

        this.password = $resource(API_URL + 'api/password', {}, {
            'get': { method: 'POST', isArray: false },
            'save': { method: 'PUT', isArray: false }
        })

        this.simcards = $resource(API_URL + 'api/simcards/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getSimcardToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'importIsCompleted': { method: 'POST', params: { method: 'import', type: 'IsCompleted' } },
            'importResume': { method: 'POST', params: { method: 'import', type: 'Resume' } },
            'importInit': { method: 'POST', params: { method: 'import', type: 'init' } },
            'importValidate': { method: 'GET', params: { method: 'import', type: 'Validate' } },
            'importGetData': { method: 'GET', params: { method: 'import', type: 'getData' } },
            'importStart': { method: 'GET', params: { method: 'import', type: 'start' } },
            'importStop': { method: 'GET', params: { method: 'import', type: 'stop' } },
            'importProgress': { method: 'GET', params: { method: 'import', type: 'progress' } },
            'importSummary': { method: 'GET', params: { method: 'import', type: 'summary' } }
        })

        this.reports = $resource(API_URL + 'api/reports/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'getReportToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'generateReport': { method: 'GET', params: { method: 'generate' }, cancellable: true },
        })

        this.ssrs_reports = $resource(API_URL + "api/ssrsreport/:id/:method", {}, {
                'query': { method: "POST", isArray: false, timeout: 72000000, cancellable: true },
                'get': { method: "GET", cancellable: true },
                'generateReport': { method: "POST", params: { method: "generate" }, cancellable: true },
                'findstring': { method: "POST", params: { method: "findstring" }, cancellable: true }
            });

        this.scripts = $resource(API_URL + 'api/scripts/:id/:method', {}, {
            'get': { method: 'GET', cancellable: true },
            'scriptStart': { method: 'POST', params: { method: 'scriptStart' } },
            'scriptStop': { method: 'POST', params: { method: 'scriptStop' } },
            'scriptStatus': { method: 'POST', params: { method: 'scriptStatus' } },
            'getScriptResult': { method: 'POST', params: { method: 'getScriptResult' } }
        })

        this.contacts = $resource(API_URL + 'api/contacts/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getContactGroups': { method: 'POST', params: { method: 'groups' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'get': { method: 'GET', cancellable: true }
        })

        this.actions = $resource(API_URL + 'api/actions/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getActionToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },
            'get': { method: 'GET', cancellable: true },
            'getPackets': { method: 'GET', isArray: false, params: { method: 'Packets' }, cancellable: true },
            'checkActionStatus': { method: 'POST', isArray: false, params: { id: 'Status', method: 'Check' }, cancellable: true }
        })

        this.secureapp = $resource(API_URL + 'api/secureapp/:id/:method', {}, {            
            'getOperatorSettings': { method: 'GET', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'get' } },
            'saveOperatorSettings': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'save' } },
            'getReferenceObjectList': { method: 'POST', isArray: false, params: { method: 'reference' }, cancellable: true },
            'getReferenceObject': { method: 'POST', isArray: false, params: { method: 'referenceObject' }, cancellable: true },    
        })

        this.kpi = $resource(API_URL + 'api/lpgkpi/:method', {}, {
            'getAggregationPeriods': { method: 'GET', params: { method: 'aggregation-periods' }, isArray: false, timeout: 72000000, cancellable: true },
            'getKpiData': { method: 'POST', params: { method: 'kpi-data' }, timeout: 72000000, cancellable: true },
            'getKpiLocations': { method: 'POST', params: { method: 'kpi-locations' }, timeout: 72000000, cancellable: true },
            'getKpiMeters': { method: 'POST', params: { method: 'kpi-meters' }, timeout: 72000000, cancellable: true },
            'getKpiDates': { method: 'GET', params: { method: 'kpi-dates' }, timeout: 72000000, cancellable: true }
        });

        this.servicemans = $resource(API_URL + 'api/servicemans/:id/:method', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getAllServicemans': { method: 'POST', isArray: false, params: { method: 'all' }, timeout: 72000000, cancellable: true },
            'get': { method: 'GET', cancellable: true }
        })

        this.depositories = $resource(API_URL + 'api/depositories/:id/:method/:guid/:type', {}, {
            'query': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true },
            'getDepositoryToEdit': { method: 'GET', params: { method: 'edit' }, cancellable: true },
            'save': { method: 'PUT', isArray: false },
            'delete': { method: 'DELETE', isArray: false },            
            'get': { method: 'GET', cancellable: true },
            'getDepositoryContent': { method: 'GET', cancellable: true, isArray: false, params: { method: 'depository', type: 'content' } },
            'changeLocationEquipment': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'depository', type: 'change' } },
            'validateLocationEquipmentChange': { method: 'POST', isArray: false, timeout: 72000000, cancellable: true, params: { method: 'depository', type: 'validate' } }
        })
    }
}